<template>
	<div class="attend-card-wrapper d-flex align-center px-8 py-6 mb-4">
		<Avatar
			class="mr-8 post-preview-card__avatar"
			ize="85"
			:avatar="speaker.speaker_logo"
		/>
		<div>
			<div
				v-if='speaker.speaker_name'
				class="attend-card-tittle mb-2"
			>
				{{ speaker.speaker_name }}
			</div>
			<div
				v-if='speaker.speaker_title'
				class="attend-card-location mb-2"
			>
				{{ speaker.speaker_title }}
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Avatar from '@/components/Avatar.vue'
import ResourceList from '@/components/Resource/ResourceList.vue'
import SessionAttachments from '@/components/Resource/SessionAttachments.vue'

Vue.use(VueScrollTo)

export default {
	name: 'SpeakerCard',
	components: { SessionAttachments, ResourceList, Avatar },

	props: {
		speaker: {
			type: Object,
			default: () => {},
		},
	},

	methods: {
		//
	},
}
</script>

<style lang="scss">
.agenda-card {
	&-wrapper {

	}

	&-date {
		color: rgb(74, 74, 74);
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}

	&-description {
		color: rgb(74, 74, 74);
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		line-height: 20px;
	}

	&-tag {
		color: rgb(106, 167, 80);
		font-size: 13px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}

	&-location {
		display: flex;
		color: rgb(153, 153, 153);
		font-size: 13px;
		font-family: Montserrat, sans-serif;
		font-weight: 600;
		line-height: 17px;

		i {
			color: rgb(153, 153, 153) !important;
		}
	}
}
</style>
